import { useEffect } from 'react';
import { phraseConsultation } from '../api/useConsultations';
import { C } from '../theme/palette';

/** Durée pendant laquelle le signal reste à l'écran. */
export const DUREE_SIGNAL_MS = 8000;

/**
 * Le signal qui descend en haut de l'écran quand un client vient d'ouvrir son
 * offre ou sa facture. Le toucher ouvre les notifications.
 *
 * @param {object} props propriétés
 * @param {?object} props.consultation ouverture à annoncer, rien sans elle
 * @param {() => void} props.onFerme le signal disparaît
 * @param {() => void} props.onOuvre ouvre les notifications
 * @param {string} [props.motOffre] mot de la société pour l'offre
 * @returns {import('react').ReactElement|null} le signal
 */
export function SignalConsultation({ consultation, onFerme, onOuvre, motOffre }) {
  useEffect(() => {
    if (!consultation) return undefined;
    const minuteur = setTimeout(onFerme, DUREE_SIGNAL_MS);
    return () => clearTimeout(minuteur);
    // Un nouveau signal repart pour toute la durée.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [consultation?.id]);
  if (!consultation) return null;
  return (
    <div
      className="no-print"
      role="alert"
      onClick={() => {
        onFerme();
        onOuvre();
      }}
      style={{
        position: 'absolute',
        left: 10,
        right: 10,
        top: 'calc(var(--st-haut) + 10px)',
        zIndex: 70,
        background: C.navy,
        color: '#fff',
        borderRadius: 14,
        padding: '11px 14px',
        boxShadow: '0 10px 30px rgba(15,23,42,.35)',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        cursor: 'pointer',
      }}
    >
      <span style={{ fontSize: 22 }}>👀</span>
      <div style={{ minWidth: 0, flex: 1 }}>
        <div style={{ fontSize: 12.5, fontWeight: 800 }}>
          {phraseConsultation(consultation, motOffre)}
        </div>
        <div style={{ fontSize: 10.5, opacity: 0.8 }}>à l’instant · touche pour voir</div>
      </div>
      <button
        type="button"
        aria-label="Fermer"
        onClick={(e) => {
          e.stopPropagation();
          onFerme();
        }}
        style={{
          border: 'none',
          background: 'none',
          color: '#fff',
          fontSize: 15,
          cursor: 'pointer',
        }}
      >
        ✕
      </button>
    </div>
  );
}
